export default __webpack_public_path__ + "static/media/repeated-alerts-icon.0cc3cad0.svg";